(function () {
  const PHONE_ERROR = () => window.oneclickStrings?.validationError || 'Вкажіть номер у форматі +380 XX XXX XX XX.';
  const NAME_ERROR = () => window.oneclickStrings?.nameError || 'Вкажіть імʼя.';
  const EP_EMPTY_ERROR = () => window.oneclickStrings?.notLive || 'One-click не підключено.';
  const DEFAULT_ERROR = () => window.oneclickStrings?.error || 'Не вдалося надіслати заявку.';

  const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

  const UA_MOBILE_SUBSCRIBER = /^(?:39|50|63|66|67|68|73|9[1-9])\d{7}$/;

  const normalizeUaPhone = (value) => {
    let d = digitsOnly(value);
    if (d.startsWith('380')) d = d.slice(3);
    else if (d.startsWith('80')) d = d.slice(2);
    else if (d.startsWith('0')) d = d.slice(1);
    return UA_MOBILE_SUBSCRIBER.test(d) ? `+380${d}` : '';
  };

  const isValidUaPhone = (value) => normalizeUaPhone(value) !== '';

  const friendlyError = (raw) => {
    const text = String(raw || '').trim();
    if (!text) return DEFAULT_ERROR();
    if (text.length > 160 || /^HTTP\s|Shopify|GraphQL|KeyCRM|[{}[\]]|TypeError|Failed to fetch|NetworkError|Load failed/i.test(text)) {
      return DEFAULT_ERROR();
    }
    return text;
  };

  const PHONE_PREFIX = '+380';
  const PHONE_EMPTY = PHONE_PREFIX + ' ';

  const groupPhoneRest = (rest) => {
    const g = [rest.slice(0, 2), rest.slice(2, 5), rest.slice(5, 7), rest.slice(7, 9)].filter(Boolean);
    return g.length ? PHONE_PREFIX + ' ' + g.join(' ') : PHONE_EMPTY;
  };

  const setupPhonePrefix = (el) => {
    if (!el) return;
    const enforce = () => {
      let rest = digitsOnly(el.value);
      if (rest.indexOf('380') === 0) rest = rest.slice(3);
      if (rest.indexOf('0') === 0) rest = rest.slice(1);
      rest = rest.slice(0, 9);
      const next = groupPhoneRest(rest);
      if (el.value !== next) el.value = next;
      if (el.selectionStart !== null && el.selectionStart < PHONE_PREFIX.length + 1) {
        try {
          el.setSelectionRange(next.length, next.length);
        } catch (_) {
        }
      }
    };
    if (!digitsOnly(el.value)) el.value = PHONE_EMPTY;
    el.addEventListener('focus', enforce);
    el.addEventListener('input', enforce);
  };

  const setMessage = (messageEl, text, isError = true) => {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.hidden = false;
    messageEl.classList.toggle('gm-oneclick__message--error', isError);
    messageEl.classList.toggle('gm-oneclick__message--success', !isError);
  };

  const getOrderReference = (data, fallback) => {
    if (data && typeof data === 'object') {
      return data.order_reference || data.orderReference || data.reference || data.orderId || data.id || fallback;
    }
    return fallback;
  };

  class GetmanOneclick {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || '';
      this.endpoint = root.dataset.endpoint || '';
      this.header = root.querySelector('.gm-oneclick__header');
      this.form = root.querySelector('[data-gm-oneclick-form]');
      this.submit = root.querySelector('[data-gm-oneclick-submit]');
      this.message = root.querySelector('[data-gm-oneclick-message]');
      this.loading = root.querySelector('[data-gm-oneclick-loading]');
      this.success = root.querySelector('[data-gm-oneclick-success]');
      this.orderRef = root.querySelector('[data-gm-oneclick-order-ref]');
      this.variantField = root.querySelector('[data-gm-oneclick-variant-id]');
      this.phoneInput = root.querySelector('input[name="phone"]');
      this.nameInput = root.querySelector('input[name="name"]');
      this.trigger = document.querySelector(
        `modal-opener[data-modal="#GmOneClick-${CSS.escape(this.sectionId)}"] [data-gm-oneclick-trigger]`
      );

      this.validators = [
        { el: this.nameInput, fn: (v) => (String(v || '').trim() ? '' : NAME_ERROR()) },
        { el: this.phoneInput, fn: (v) => (isValidUaPhone(v) ? '' : PHONE_ERROR()) },
      ];

      this.bind();
      this.syncVariantState();
      this.setPhase('form');
    }

    bind() {
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submitForm();
      });

      setupPhonePrefix(this.phoneInput);

      this.phoneInput?.addEventListener('input', () => {
        if (this.message && !this.message.hidden) {
          this.message.hidden = true;
        }
      });

      this.validators.forEach(({ el, fn }) => {
        if (!el) return;
        el.addEventListener('input', () => this.setFieldError(el, ''));
        el.addEventListener('blur', () => {
          const hasContent =
            el === this.phoneInput
              ? digitsOnly(el.value).replace(/^380/, '').length > 0
              : String(el.value || '').trim().length > 0;
          if (hasContent) this.setFieldError(el, fn(el.value));
        });
      });

      this.trigger?.addEventListener('click', () => {
        this.reset();
      });

      document.body.addEventListener('modalClosed', () => {
        window.setTimeout(() => {
          if (!this.root.closest('modal-dialog')?.hasAttribute('open')) {
            this.reset();
          }
        }, 0);
      });

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event.data || String(event.data.sectionId) !== this.sectionId) return;
        this.applyVariant(event.data.variant);
      });
    }

    syncVariantState() {
      const section = document.querySelector(`product-info[data-section="${CSS.escape(this.sectionId)}"]`);
      const variant = section?.querySelector('input.product-variant-id')?.value;
      if (!variant) return;
      this.variantField.value = variant;
    }

    applyVariant(variant) {
      if (!variant) {
        if (this.trigger) {
          this.trigger.disabled = true;
          this.trigger.setAttribute('aria-disabled', 'true');
        }
        return;
      }

      if (this.variantField) {
        this.variantField.value = variant.id;
      }

      if (this.trigger) {
        this.trigger.disabled = !variant.available;
        if (variant.available) {
          this.trigger.removeAttribute('aria-disabled');
        } else {
          this.trigger.setAttribute('aria-disabled', 'true');
        }
      }
    }

    setPhase(phase) {
      const showForm = phase === 'form';
      const showLoading = phase === 'loading';
      const showSuccess = phase === 'success';
      if (this.header) this.header.hidden = !showForm;
      if (this.form) this.form.hidden = !showForm;
      if (this.loading) this.loading.hidden = !showLoading;
      if (this.success) this.success.hidden = !showSuccess;
    }

    reset() {
      const currentVariantId = this.variantField?.value || '';
      if (this.form) this.form.reset();
      if (this.variantField && currentVariantId) {
        this.variantField.value = currentVariantId;
      }
      if (this.message) {
        this.message.hidden = true;
        this.message.classList.remove('gm-oneclick__message--success', 'gm-oneclick__message--error');
      }
      this.validators?.forEach(({ el }) => this.setFieldError(el, ''));
      if (this.phoneInput) this.phoneInput.value = PHONE_EMPTY;
      if (this.submit) {
        this.submit.disabled = false;
        this.submit.textContent = window.oneclickStrings?.submit || 'Надіслати';
      }
      this.setPhase('form');
    }

    setFieldError(input, text) {
      if (!input) return;
      const wrap = input.closest('.gm-oneclick__field');
      const errEl = wrap && wrap.querySelector('[data-gm-oneclick-error-for]');
      if (errEl) {
        errEl.textContent = text || '';
        errEl.hidden = !text;
      }
      input.setAttribute('aria-invalid', text ? 'true' : 'false');
    }

    validateAll() {
      let firstBad = null;
      this.validators.forEach(({ el, fn }) => {
        if (!el) return;
        const err = fn(el.value);
        this.setFieldError(el, err);
        if (err && !firstBad) firstBad = el;
      });
      if (firstBad) {
        firstBad.focus();
        return false;
      }
      return true;
    }

    showError(text) {
      setMessage(this.message, text || DEFAULT_ERROR(), true);
      if (this.submit) {
        this.submit.disabled = false;
        this.submit.textContent = window.oneclickStrings?.submit || 'Надіслати';
      }
      this.setPhase('form');
    }

    showSuccess(reference) {
      if (this.orderRef) {
        this.orderRef.textContent = reference
          ? `${window.oneclickStrings?.successOrderPrefix || 'Номер заявки:'} ${reference}`
          : '';
      }
      if (this.message) this.message.hidden = true;
      this.setPhase('success');
    }

    async submitForm() {
      if (!this.endpoint) {
        this.showError(EP_EMPTY_ERROR());
        return;
      }

      if (!this.validateAll()) return;

      const formData = new FormData(this.form);
      formData.set('name', String(formData.get('name') || '').trim());
      formData.set('phone', normalizeUaPhone(String(formData.get('phone') || '')));
      formData.set('source', '1-клік');

      if (this.message) this.message.hidden = true;
      this.setPhase('loading');

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(Object.fromEntries(formData.entries())),
        });

        const contentType = response.headers.get('content-type') || '';
        let data = null;
        if (contentType.includes('application/json')) {
          data = await response.json();
        } else {
          data = await response.text();
        }

        if (!response.ok) {
          throw new Error(typeof data === 'string' ? data : data?.error || DEFAULT_ERROR());
        }

        this.showSuccess(getOrderReference(data, `#${Date.now().toString().slice(-6)}`));
      } catch (error) {
        console.warn('[getman-oneclick] submit failed:', error);
        this.showError(friendlyError(error && error.message));
      }
    }
  }

  document.querySelectorAll('[data-gm-oneclick-root]').forEach((root) => {
    new GetmanOneclick(root);
  });
})();
